import { render, staticRenderFns } from "./RooofAccountList.vue?vue&type=template&id=254a9662&scoped=true&"
import script from "./RooofAccountList.vue?vue&type=script&lang=js&"
export * from "./RooofAccountList.vue?vue&type=script&lang=js&"
import style0 from "./RooofAccountList.vue?vue&type=style&index=0&id=254a9662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254a9662",
  null
  
)

export default component.exports